import React from "react";
import styled from "styled-components";

const HeaderContainer = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 0;

	h1,
	h2,
	h3 {
		margin: 0;
		padding: 0;
	}
`;

const ActionHeader = (props: any) => {
	return (
		<HeaderContainer>
			{props.children.length >= 1 && props.children[0]}
			{props.children.length >= 2 && (
				<div>
					{props.children.map((child: any, i: number) => {
						return i == 0 ? null : child;
					})}
				</div>
			)}
		</HeaderContainer>
	);
};
export default ActionHeader;
